var map = {
	"./angle-left.svg": 7168,
	"./avatar.svg": 2195,
	"./bar.svg": 8635,
	"./boss_i.svg": 6411,
	"./boss_y.svg": 2060,
	"./business-and-trade.svg": 9404,
	"./check.svg": 5541,
	"./close.svg": 4513,
	"./dot.svg": 9657,
	"./fact1.svg": 3098,
	"./fact2.svg": 8649,
	"./fact3.svg": 497,
	"./fact4.svg": 188,
	"./hospital.svg": 8520,
	"./hourglass.svg": 119,
	"./instagram.svg": 2215,
	"./kindergarten.svg": 5028,
	"./left-arrow.svg": 8268,
	"./lock.svg": 1173,
	"./mail.svg": 2240,
	"./map_marker.svg": 6855,
	"./map_marker_b.svg": 3108,
	"./mob_call.svg": 8827,
	"./mob_telegram.svg": 8423,
	"./mob_whatsapp.svg": 858,
	"./phone.svg": 8597,
	"./play-button.svg": 1588,
	"./push-pin.svg": 6968,
	"./school.svg": 2058,
	"./spinner-third.svg": 1574,
	"./spinner.svg": 7457,
	"./sunbed.svg": 661,
	"./telegram-plane.svg": 265,
	"./three-buildings.svg": 9934,
	"./undo.svg": 7265,
	"./vk.svg": 5593,
	"./wh1.svg": 8436,
	"./wh2.svg": 6625,
	"./wh3.svg": 5521,
	"./wh4.svg": 2845,
	"./whatsapp.svg": 8296,
	"./youtube.svg": 3158,
	"./zoom.svg": 3571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5466;